import { render } from "./ofQuery.vue?vue&type=template&id=00851d49"
import script from "./ofQuery.vue?vue&type=script&lang=js"
export * from "./ofQuery.vue?vue&type=script&lang=js"

import "./ofQuery.vue?vue&type=style&index=0&id=00851d49&lang=css"

import exportComponent from "C:\\projects\\e2efreight\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__